// extracted by mini-css-extract-plugin
export default {"portfolioContainer":"portfolioPage_portfolioContainer__XX3lV"};